(ns common.schema.entities.sales-opportunity.core
  (:require [common.schema.entities.sales-opportunity.permissions :as permissions]
            [common.schema.entities.sales-opportunity.schema :as schema]))

(def entity-type-definition
  {:entity-type                  :entity.type/sales-opportunity
   :schema                       schema/schema
   :name                         {:en "Opportunity"}
   :plural                       {:en "Opportunities"}
   :icon                         :fa-search-dollar
   :create-icon                  :fa-bullseye-pointer

   :display-name-fn              (fn [{:keys [entity]}]
                                   (:sales-opportunity/name entity))
   :display-name/depends-on      [:sales-opportunity/name]

   :search                       {:result/title-attr     :sales-opportunity/name
                                  :result/subtitle-attrs [:sales-opportunity/status
                                                          :sales-opportunity/stage]
                                  :indexing              {:change-listening?         true
                                                          :select-searchable?        true
                                                          :dedicated-index?          true
                                                          :associated-entity-fields  #{:sales-opportunity/customer}
                                                          :name-field                "extras.full-name"
                                                          :universal-filters         {[:extras :pipeline] {:type "number"}}
                                                          :show-in-universal-search? true}
                                  :list/default-columns  [:sales-opportunity/name
                                                          :sales-opportunity/customer
                                                          :sales-opportunity/next-steps
                                                          :sales-opportunity/stage
                                                          :sales-opportunity/status
                                                          :sales-opportunity/probability-percentage
                                                          :sales-opportunity/owner]
                                  :list/default-sort     [:sales-opportunity/name :asc]
                                  :quick-filters         [:sales-opportunity/status
                                                          :sales-opportunity/stage]
                                  :views                 {:grid   {:po-default-field-paths [[:sales-opportunity/name]
                                                                                            [:sales-opportunity/customer]
                                                                                            [:sales-opportunity/next-steps]
                                                                                            [:sales-opportunity/stage]
                                                                                            [:sales-opportunity/status]
                                                                                            [:sales-opportunity/probability-percentage]
                                                                                            [:sales-opportunity/owner]]
                                                                   :mandatory-field-paths  [[:sales-opportunity/name]]
                                                                   :pinned-field-paths     {:left [[:sales-opportunity/name]]}}
                                                          :kanban {:group-by-field :sales-opportunity/stage
                                                                   :card           {:header-fields [:sales-opportunity/name]
                                                                                    :body-fields   [:sales-opportunity/customer
                                                                                                    :sales-opportunity/next-steps
                                                                                                    :sales-opportunity/status
                                                                                                    :sales-opportunity/probability-percentage
                                                                                                    :sales-opportunity/owner]
                                                                                    :footer-fields [:common/updated-on]
                                                                                    :meta-fields   [:sales-opportunity/status]}}}}

   :reporting                    {:export/default-fields
                                  [:sales-opportunity/name
                                   :sales-opportunity/customer
                                   :sales-opportunity/stage
                                   :sales-opportunity/status
                                   :sales-opportunity/probability-percentage
                                   :common/created-on
                                   :common/updated-on]
                                  :export/filename-template "sales_opportunities_{{date}}.csv"}

   :permissions                  {:creatable?   true
                                  :disableable? true}

   :mcp                          {:creatable? true}

   :read-permissions-check-fn    permissions/read-permissions?
   :disable-permissions-check-fn permissions/disable-permissions?})
